var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Product",
      "bg": "/images/sub/visual/sv5.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v("Product")])]), _c('v-tabs', {
    staticClass: "v-tab--primary",
    attrs: {
      "value": _vm.tab,
      "grow": "",
      "show-arrows": "",
      "center-active": ""
    }
  }, _vm._l(_vm.tabs, function (_ref) {
    var value = _ref.value,
        text = _ref.text;
    return _c('v-tab', {
      key: value,
      attrs: {
        "to": "/ko/product/".concat(value)
      }
    }, [_c('span', [_vm._v(_vm._s(text))])]);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0"
  }, [_c('v-tabs-items', {
    attrs: {
      "value": _vm.tab,
      "touchless": ""
    }
  }, [_c('analyzer-package'), _c('cems-aqms'), _c('liquid-analyzer'), _c('sampling'), _c('corrosion-monitoring')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }